// extracted by mini-css-extract-plugin
export default {"overlay":"SuccessOverlay_overlay__QFpJ-","card":"SuccessOverlay_card__VIVTS","checkmark":"SuccessOverlay_checkmark__TeCp1"};